<template>
  <div v-for="customer in customers" :key="customer.customerId" tabindex="0">
    <SearchBarCustomersItem
      :first-name="customer.firstName"
      :last-name="customer.lastName"
      :email="customer.email"
      :customer-id="customer.customerId"
      @view-profile="$emit('viewProfile', customer.customerId)"
    />
  </div>
</template>

<script setup lang="ts">
import { DTODataScienceSearchCustomerHit } from "vue-app/api/dto";
import SearchBarCustomersItem from "./SearchBarCustomersItem.vue";

interface Props {
  customers: DTODataScienceSearchCustomerHit[];
}

interface Emits {
  viewProfile: [customerId: number];
}

defineProps<Props>();
defineEmits<Emits>();
</script>
